<template>
<div>
  <v-layout class="pt-3" row wrap justify-center>
    <v-flex class="-secondary--text headline text-xs-center px-2 pb-1" xs12>
      <b>{{user.firstName + ' ' + user.lastName}}</b>
    </v-flex>
    <v-flex class="-secondary--text title text-xs-center px-2 pb-4" xs12>
      {{user.email}} | {{user.phone}}
    </v-flex>
    <v-flex class="title text-xs-center px-2 pb-2" xs12>
      <b>Account Created On</b><br>
      <span>{{dateCreated}}</span>
    </v-flex>
    <v-flex class="title text-xs-center px-2 pb-4" xs12>
      <b>Last Online</b><br>
      <span>{{lastSeen}}</span>
    </v-flex>
    <v-flex class="title text-xs-center px-2 pb-4" xs12>
      <div v-if="!editing">
        <b>User Type: </b>
        <span>{{user.type}}</span><br>
        <v-btn @click.native="startEditting" class="my-1" color="primary" flat small><b>Change</b></v-btn>
      </div>
      <div v-else>
        <v-layout row wrap justify-center>
          <v-flex class="px-3" xs12 sm8 md5>
            <v-select
              label="User Type"
              v-model="newType"
              :items="['Student', 'Admin']"
              hide-details
            ></v-select>
            <v-btn @click.native="changeType" class="my-1" color="success" :disabled="saving" :loading="saving" depressed small>Save</v-btn>
            <v-btn @click.native="editing = false" class="my-1" color="error" flat small>Cancel</v-btn>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
export default {
  data: () => ({
    userData: {},
    newType: '',
    editing: false,
    saving: false
  }),
  computed: {
    user () {
      this.userData = {...this.$store.getters.userById(this.$route.params.uid)}
      return this.$store.getters.userById(this.$route.params.uid)
    },
    dateCreated () {
      if (this.userData.dateCreated) {
        return new Date(this.userData.dateCreated).toLocaleString()
      } else return 'no value'
    },
    lastSeen () {
      if (this.userData.lastLogin) {
        return new Date(this.userData.lastLogin).toLocaleString()
      } else return 'no value'
    }
  },
  methods: {
    startEditting () {
      this.newType = this.userData.type
      this.editing = true
    },
    changeType () {
      if (this.newType !== this.userData.type) {
        this.saving = true
        const newUser = {
          ...this.userData,
          type: this.newType
        }
        this.$store.dispatch('updateUser', newUser).then(() => {
          const appMsg = {
            type: 'success',
            msg: this.user.firstName + ' ' + this.user.lastName + ' has been changed to a ' + this.newType
          }
          this.$store.dispatch('showAppMsg', appMsg)
          this.saving = false
        })
      } else {
        const appMsg = {
          type: 'error',
          msg: 'No change detected'
        }
        this.$store.dispatch('showAppMsg', appMsg)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UserDetails.vue